export default __webpack_public_path__ + "static/silkserif-regular-21eaf7df0f917c51bafd69e005b0150b.woff";